import { render } from "./OtherOptionTextForm.vue?vue&type=template&id=4bd704b3&scoped=true"
import script from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"
export * from "./OtherOptionTextForm.js?vue&type=script&lang=js&external"

import "./OtherOptionTextForm.vue?vue&type=style&index=0&id=4bd704b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd704b3"]])

export default __exports__